import moment from 'moment'

export interface WeeklyCommitmentCandidate {
  taskId: string
  name: string
  type: string
  position?: string
  performerIds: string[]
  performerLabels: string[]
  suggestedPromisedDate: string
  openRestrictions: number
}

const getUserId = (user: any): string => typeof user === 'string' ? user : `${user?._id || ''}`

const getUserLabel = (user: any): string => {
  if (typeof user === 'string') return user
  const name = [ user?.name, user?.surname ].filter(Boolean).join(' ').trim()
  return name || user?.email || ''
}

const clampPromisedDate = (date: string, startDay: string, endDay: string): string => {
  const value = moment(date)
  const start = moment(startDay, 'YYYY-MM-DD')
  const end = moment(endDay, 'YYYY-MM-DD')

  if (!value.isValid()) return endDay
  if (value.isBefore(start, 'day')) return startDay
  if (value.isAfter(end, 'day')) return endDay
  return value.format('YYYY-MM-DD')
}

export const getWeeklyCommitmentCandidates = (
  list: any[] = [],
  startDay: string,
  endDay: string,
): WeeklyCommitmentCandidate[] => {
  const candidates: WeeklyCommitmentCandidate[] = []

  const visit = (items: any[]) => {
    items.forEach((item: any) => {
      if (item.type !== 'task') {
        visit(item.group?.items || [])
        return
      }

      const task = item.task
      if (!task?._id || ![ 'trabajo', 'tarea' ].includes(task.type)) return
      if (task.hasSubTasks || item.subTasks?.length) return

      const responsibles = task.responsibles || []
      candidates.push({
        taskId: `${task._id}`,
        name: task.name || '',
        type: task.type,
        position: task.position,
        performerIds: responsibles.map(getUserId).filter(Boolean),
        performerLabels: responsibles.map(getUserLabel).filter(Boolean),
        suggestedPromisedDate: clampPromisedDate(task.endsAt, startDay, endDay),
        openRestrictions: (task.restrictions || []).filter((restriction: any) => !restriction.checked).length,
      })
    })
  }

  visit(list)
  return candidates
}

